/**
 * External Dependencies
 */

/**
 * Local imports
 */
import {initTrackingEvents} from "./Core/_tracking";
import initSlider from "./Core/Slider";
import initMenu from "./Core/Menu";
import initResearch from "./Core/Research";
import initAjax from "./Core/Ajax";
import initAnchors from "./Core/Anchors";
import initGravityForm from "./Core/GravityForm";
import initQuestions from "./Core/Faq";
import initMap from "./Core/Map";

initTrackingEvents();

document.addEventListener('DOMContentLoaded', () => {
  initSlider();
  initMenu();
  initResearch();
  initAjax();
  initQuestions();
  initAnchors();
  initGravityForm();
  initMap();
});
